import { showToast } from "utils/swalToast"

//config para traer la url
import config from "config"

async function fetchPost(data) {
  let url = `${config.api.baseURL}/roles`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "POST",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: ` Bearer ${token}`,
    },
  })
    .then((r) => {
      if (r.ok) {
        // La respuesta es exitosa (200 OK) pero sin contenido, así que devolvemos solo el estado
        return { status: r.status, body: null }
      } else {
        // Si hay un error, lanzamos una excepción para manejarlo en el bloque .catch
        return r.json().then((data) => {
          throw new Error(data.error || "Error desconocido")
        })
      }
    })
    .then((response) => {
      const elem = document.getElementById("formAddDis")
      if (response.status === 200) {
        if (elem) {
          elem.reset()
        }
        return response.body
      }
    })
    .catch((error) => {
      showToast({
        icon: "info",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchRolById(id) {
  let url = `${config.api.baseURL}/roles/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error al obtener los datos del rol")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function fetchPermisos(id) {
  let url = `${config.api.baseURL}/roles/permisos`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "GET",
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Error al obtener los datos del rol")
      }
      return response.json()
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

async function updateRoles(id, data) {
  let url = `${config.api.baseURL}/roles/${id}`
  const token = (sessionStorage.getItem("token") || localStorage.getItem("token"))

  return fetch(url, {
    method: "PUT",
    body: JSON.stringify(data),
    headers: {
      "Content-type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })
    .then((response) => {
      if (!response.ok) {
        return response.json().then((error) => {
          showToast({
            icon: "error",
            title: "Error al actualizar",
            text: error.message || "No se pudo actualizar el rol",
          })
          throw new Error(error.message || "No se pudo actualizar el rol")
        })
      } else {
        return response.json()
      }
    })
    .catch((error) => {
      showToast({
        icon: "error",
        title: "Error",
        text: error.message,
      })
      throw error
    })
}

export { updateRoles, fetchPermisos }

export { fetchRolById }

export { fetchPost }
